import React from 'react';
import DevelopmentInProgress from '../../../../components/common/DevelopmentInProgress';

export default function PurchaseBillsGeneral({ setError, error, setForm, form }) {
	return <DevelopmentInProgress />;
}
